<div id="penalty-touch-map"></div>
